const faturamentoRoutes = [
  {
    path: '/faturamento/ranking-vendas-cliente',
    name: 'faturamento.ranking-vendas-cliente',
    component: () => import('../views/faturamento/RankingVendasCliente.vue'),
  },
];

export default faturamentoRoutes;
